module.exports = __webpack_public_path__ + "static/green_divider_right-926e87bd01b5d3a56e72072e020622ea.png";